export default function LoginRedirect() {
  if (typeof window !== "undefined")
    window.location = `${process.env.TRAVALA_URL}/account`

  return null
}
